import customaxios from '.';

export const preRegisterPartner = (data: any) => {
  return customaxios({
    method: "POST",
    url: `/provider/pre-register`,
    data,
  });
};

export const registerPartner = (data: any) => {
  return customaxios({
    method: "POST",
    url: `/provider/register`,
    data,
  });
};

export const getServiceCategories = (category: string) => {
  return customaxios({
    method: "GET",
    url: `/services?type=${category}`,
  });
};